import React from 'react';
import './Projects.css';

const projects = {
    personal: [
        {
            id: 1,
            title: 'Lithium Ion Battery Simulator',
            description: 'An industry-driven final year university project in collaboration with Analog Devices and Atlantic Technological University. Parameter identification using experimental battery lab data to estimate the component values of an equivalent circuit model, accessible through an api andpoint for custom simulations of the model.',
            demoLink: 'https://markveerasingam.com/projects/battery-simulator',
            interactive: false,
            technologies: ['Python', 'NumPy', 'PyBaMM'],
            attachments: [
                {
                    name: 'Final Report',
                    url: '.../public/pdf/ProjectEngReportMarkVeerasingam.pdf',
                },
            ],
            image: '/images/battsim.gif'
        },
    ],
    openSource: [
        {
            id: 1,
            title: 'Numba',
            description: [
                'Contributed to the multi architecture support of Numba, contributing to the support of s390x',
                '- Added a type-promotion check (sign-extension, zero-extension) to fill register bits for foreign function calls to adhere to ABIs outside x86_64.',
                '- Contributed to SIMD array alignment for non Intel (32-byte AVX ISA)',
                '- Influenced and contribtued to the Numba tier system for multi-archiecture, placing s390x in Tier 2'
            ],
            contributions: [
                { label: 'ABI Type Promotion', url: 'https://github.com/numba/numba/pull/10396' },
                { label: 'SIMD Array Alignment', url: 'https://github.com/numba/numba/pull/10410' },
                { label: 's390x Tier 2 Support', url: 'https://numba.readthedocs.io/en/stable/reference/support_tiers.html#id1' },
            ],
            organisations: ['Anaconda', 'NVIDIA'],
            link: 'https://github.com/numba/numba',
            webLink: 'https://numba.pydata.org/',
            technologies: ['Python, LLVM'],
            image: '/images/numba.png',
        },
    ],
    public: [
        {
            id: 1,
            title: 'TRIDENT',
            description: 'A €3.5 million DTIF-funded project by the Irish Government focused on battery research and system innovation. Developed embedded software for a multi-processor microcontroller to support heterogeneous computing and algorithm processing adjacent to the core OS.',
            organisations: ['Irish Government', 'University of Limerick', 'Analog Devices'],
            technologies: ['Embedded Systems', 'Machine Learning', 'Battery Systems'],
            image: '/images/dept_trade_enterprise.png',
            webLink: 'https://enterprise.gov.ie/en/news-and-events/department-news/2024/may/070520241.html#:~:text=TRIDENT%20%E2%80%93%20University%20of,materials%20and%20processes.',
        },
    ],
};

const ProjectItem = ({ project }) => (
    <div className="project-item">
        <h3>{project.title}</h3>
        {project.image && (
            <img src={project.image} alt={project.title} className="project-image" />
        )}

        {/* Fix: Handle array-based descriptions for Numba bullets */}
        <div className="project-description">
            {Array.isArray(project.description) ? (
                <ul className="description-list">
                    {project.description.map((line, i) => (
                        <li key={i} className="project-meta">{line}</li>
                    ))}
                </ul>
            ) : (
                <p className="project-meta">{project.description}</p>
            )}
        </div>

        {/* Fix: Added the Contributions Rendering Logic */}
        {project.contributions && (
            <div className="project-contributions">
                <strong className="project-meta" style={{ color: 'var(--color-primary)' }}>Key Contributions:</strong>
                <div className="contribution-tags">
                    {project.contributions.map((contrib, i) => (
                        <a
                            key={i}
                            href={contrib.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="contribution-tag"
                        >
                            {contrib.label} ↗
                        </a>
                    ))}
                </div>
            </div>
        )}

        {project.organisations && (
            <p className="project-meta">
                <strong>Organisations:</strong> {project.organisations.join(', ')}
            </p>
        )}
        {project.technologies && (
            <p className="project-meta">
                <strong>Technologies:</strong> {project.technologies.join(', ')}
            </p>
        )}

        <div className="project-buttons">
            {project.link && (
                <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">Github</a>
            )}
            {project.webLink && (
                <a href={project.webLink} target="_blank" rel="noopener noreferrer" className="project-link">Website</a>
            )}
        </div>
    </div>
);

const Projects = () => {
    return (
        <div className="projects-container">
            <h1>Projects</h1>

            {/* Moved Open Source to the top to show Numba first */}
            <section className="projects-section">
                <h2>Open Source Projects</h2>
                {projects.openSource.map((project) => (
                    <ProjectItem key={project.id} project={project} />
                ))}
            </section>

            <section className="projects-section">
                <h2>Personal Projects</h2>
                {projects.personal.map((project) => (
                    <ProjectItem key={project.id} project={project} />
                ))}
            </section>

            <section className="projects-section">
                <h2>Public Projects</h2>
                {projects.public.map((project) => (
                    <ProjectItem key={project.id} project={project} />
                ))}
            </section>
        </div>
    );
};

export default Projects;